import { FC, Fragment, memo } from "react";
import { FormikHandlers } from "formik";
import {
  AutocompleteFilterBody,
  AutocompleteFilterBodyProps,
} from "../AutocompleteFilterBody";
import {
  FilterItem,
  Operator,
  useGetUsersMeEcsWorkloadCapacityProvidersQuery,
} from "../../../../../../../../services/cloudchipr.api";
import { FilterItemOperatorType } from "../../../FilterItemOperatorType";
import { getCreatedByFormattedValue } from "../../../../../../utils/helpers/getCreatedByFormattedValue";

interface CapacityProvidersFilterProps extends AutocompleteFilterBodyProps {
  filter: FilterItem;
  operators?: Operator[];
  onChange: FormikHandlers["handleChange"];
}

export const CapacityProvidersFilter: FC<CapacityProvidersFilterProps> = memo(
  ({ operators, filter, onChange, ...props }) => {
    const { data, isLoading } =
      useGetUsersMeEcsWorkloadCapacityProvidersQuery();

    return (
      <Fragment>
        <FilterItemOperatorType
          onChange={onChange}
          options={operators}
          value={filter.operator || "in"}
        />

        <AutocompleteFilterBody
          {...props}
          options={data ?? []}
          isLoading={isLoading}
          label="CP Name"
          selectedValue={Array.isArray(filter?.value) ? filter.value : []}
          formatSelectedLabel={getCreatedByFormattedValue}
        />
      </Fragment>
    );
  },
);
